import { Info } from 'lucide-react';

import { Button } from '@/components/shadcn/ui/button';
import { subscriptionFormOptions } from '@/entities/(notification)/subscription';
import {
  NotificationChannelForm,
  previewNotification,
} from '@/entities/notification';
import { errorHandler } from '@/error-handler';
import { withForm } from '@/shared/ui/form';
import { toast } from '@/stores/pure/ToastStore';
import { WORKFLOW_TYPE } from '@/types/workflowConst';

export const SubscriptionActionSection = withForm({
  ...subscriptionFormOptions,
  props: {
    workspaceId: '',
  },
  render: function SubscriptionActionSection({ form, workspaceId }) {
    // Test connection 핸들러
    const handleTestConnection = async () => {
      const values = form.state.values;
      try {
         
        await previewNotification({
          workspace_id: workspaceId,
          title: values.title || 'Subscription Test',
          enable: true,
          type: WORKFLOW_TYPE.SUBSCRIPTION,
          subscription: {
            basis: values.basis,
            target: values.target,
            schedule: values.schedule,
            timezone: values.timezone,
          },
          channel: values.channel,
        } as any);
        toast('Test notification sent', 'success');
      } catch (error) {
        toast(errorHandler(error, 'Failed to test notification'), 'fail');
      }
    };

    return (
      <div className="flex flex-col gap-5 rounded-lg border p-5">
        {/* 헤더 */}
        <div className="flex items-center gap-2">
          <Info className="size-5 text-red-500" />
          <span className="text-sm font-semibold">Action</span>
        </div>

        {/* Integrate 영역 */}
        <div className="grid grid-cols-[120px_1fr] items-start gap-3">
          <span className="pt-2 text-sm text-muted-foreground">Integrate</span>
          <div className="flex flex-col gap-3">
            <form.Subscribe selector={(state) => state.canSubmit}>
              {(canSubmit) => (
                <NotificationChannelForm
                  hideEmailOption
                  form={form}
                  workspaceId={workspaceId}
                  renderTestConnection={(canSubmit) => (
                    <Button
                      variant="outline"
                      size="sm"
                      className="w-fit"
                      onClick={handleTestConnection}
                      disabled={!canSubmit}
                    >
                      Test connection
                    </Button>
                  )}
                />
              )}
            </form.Subscribe>
          </div>
        </div>
      </div>
    );
  },
});
